/**
 * Model to hold a single seasonEvent mapping.
 */
export class SeasonEvent {
    public isNew: boolean;
    public id: string;
    public identitySeasonId: string;
    public eventId: string;

    constructor(id?: string, identitySeasonId?: string, eventId?: string) {
        this.isNew = true;
        this.id = id;
        this.identitySeasonId = identitySeasonId;
        this.eventId = eventId;
    }

    public clone(): SeasonEvent {
        const clone: SeasonEvent = new SeasonEvent();
        clone.id = this.id;
        clone.identitySeasonId = this.identitySeasonId;
        clone.eventId = this.eventId;
        return clone;
    }

    public serialize(): string {
        const json: any = {
            data: {
                id: this.id,
                type: 'seasonEvent',
                attributes: {
                    identitySeasonGuid: this.identitySeasonId,
                    eventGuid: this.eventId,
                },
            },
        };

        return JSON.stringify(json);
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any): SeasonEvent {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};

        this.isNew = false;
        this.id = data.id;
        this.identitySeasonId = attrs.identitySeasonId;
        this.eventId = attrs.eventId;

        return this;
    }
}
